<div class="premium-modal-wrapper">
    <!-- ======== HEADER ======== -->
    <ion-header class="ion-no-border premium-header">
        <div class="header-curve"></div>
        <div class="custom-toolbar">
            <div class="toolbar-content">
                <div class="icon-btn" (click)="dismiss()">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </div>
                <div class="title-group">
                    <div class="title-main">{{ tituloModal }}</div>
                    <div class="title-sub">{{ moduloOrigen }}</div>
                </div>
                <div class="icon-btn" style="visibility: hidden;">
                    <ion-icon name="close"></ion-icon>
                </div>
            </div>
        </div>
    </ion-header>

    <ion-content class="content-bg" [fullscreen]="false">
        <div class="email-container ion-padding">

            <!-- ======== DESTINATARIOS ======== -->
            <div class="email-card">
                <div class="card-header">
                    <div class="header-title">
                        <ion-icon name="people-outline" color="primary"></ion-icon>
                        <span>Destinatarios</span>
                    </div>
                    <ion-button fill="clear" size="small" class="add-btn" (click)="openAddDestinatario()">
                        <ion-icon name="add-circle-outline" slot="icon-only"></ion-icon>
                    </ion-button>
                </div>

                <!-- Lista de chips de destinatarios seleccionados -->
                <div class="chips-container" *ngIf="destinatariosSeleccionados.length > 0">
                    <div class="chip" *ngFor="let dest of destinatariosSeleccionados">
                        <button class="chip-tipo-badge" [class.badge-cc]="dest.tipo === 'CC'" (click)="toggleTipoDestinatario(dest)">
                            {{ dest.tipo }}
                        </button>
                        <ion-icon name="person-circle-outline"></ion-icon>
                        <span>{{ dest.nombre }}</span>
                        <span class="chip-email">{{ dest.correo }}</span>
                        <button class="chip-remove" (click)="quitarDestinatario(dest)">
                            <ion-icon name="close-circle"></ion-icon>
                        </button>
                    </div>
                </div>

                <!-- Buscador de destinatarios -->
                <div class="search-expand" *ngIf="mostrarBuscadorDestinatario">
                    <div class="premium-input-wrapper search-input">
                        <ion-icon name="search-outline" class="search-icon"></ion-icon>
                        <input
                            #searchDest
                            type="text"
                            placeholder="Buscar solicitante..."
                            [(ngModel)]="busquedaDestinatario"
                            (input)="filtrarDestinatarios()"
                            id="input-buscar-destinatario">
                    </div>
                    <div class="search-results" *ngIf="destinatariosFiltrados.length > 0">
                        <div
                            class="result-item"
                            *ngFor="let d of destinatariosFiltrados"
                            (click)="agregarDestinatario(d)">
                            <ion-icon name="person-outline"></ion-icon>
                            <div class="result-info">
                                <span class="result-name">{{ d.nombre }}</span>
                                <span class="result-email">{{ d.correo }}</span>
                            </div>
                            <ion-icon name="add-outline" class="result-add-icon"></ion-icon>
                        </div>
                    </div>
                    <div class="no-results" *ngIf="busquedaDestinatario.length > 1 && destinatariosFiltrados.length === 0">
                        <ion-icon name="alert-circle-outline"></ion-icon>
                        <span>Sin resultados</span>
                    </div>
                </div>

                <!-- Empty state -->
                <div class="empty-state-sm" *ngIf="destinatariosSeleccionados.length === 0 && !mostrarBuscadorDestinatario">
                    <span>No hay destinatarios. Toca <strong>+</strong> para agregar.</span>
                </div>
            </div>

            <!-- ======== GRUPOS ======== -->
            <div class="email-card">
                <div class="card-header">
                    <div class="header-title">
                        <ion-icon name="layers-outline" color="secondary"></ion-icon>
                        <span>Grupos</span>
                    </div>
                    <ion-button fill="clear" size="small" class="add-btn" (click)="openAddGrupo()">
                        <ion-icon name="add-circle-outline" slot="icon-only"></ion-icon>
                    </ion-button>
                </div>

                <!-- Lista de chips de grupos seleccionados -->
                <div class="chips-container" *ngIf="gruposSeleccionados.length > 0">
                    <div class="chip chip-group" *ngFor="let grupo of gruposSeleccionados">
                        <button class="chip-tipo-badge" [class.badge-cc]="grupo.tipo === 'CC'" (click)="toggleTipoGrupo(grupo)">
                            {{ grupo.tipo }}
                        </button>
                        <ion-icon name="people-circle-outline"></ion-icon>
                        <span>{{ grupo.nombre }}</span>
                        <span class="chip-count">{{ grupo.cantidad }} contactos</span>
                        <button class="chip-remove" (click)="quitarGrupo(grupo)">
                            <ion-icon name="close-circle"></ion-icon>
                        </button>
                    </div>
                </div>

                <!-- Buscador de grupos -->
                <div class="search-expand" *ngIf="mostrarBuscadorGrupo">
                    <div class="premium-input-wrapper search-input">
                        <ion-icon name="search-outline" class="search-icon"></ion-icon>
                        <input
                            #searchGroup
                            type="text"
                            placeholder="Buscar grupo..."
                            [(ngModel)]="busquedaGrupo"
                            (input)="filtrarGrupos()"
                            id="input-buscar-grupo">
                    </div>
                    <div class="search-results" *ngIf="gruposFiltrados.length > 0">
                        <div
                            class="result-item"
                            *ngFor="let g of gruposFiltrados"
                            (click)="agregarGrupo(g)">
                            <ion-icon name="people-outline"></ion-icon>
                            <div class="result-info">
                                <span class="result-name">{{ g.nombre }}</span>
                                <span class="result-email">{{ g.cantidad }} contactos</span>
                            </div>
                            <ion-icon name="add-outline" class="result-add-icon"></ion-icon>
                        </div>
                    </div>
                    <div class="no-results" *ngIf="busquedaGrupo.length > 1 && gruposFiltrados.length === 0">
                        <ion-icon name="alert-circle-outline"></ion-icon>
                        <span>Sin resultados</span>
                    </div>
                </div>

                <!-- Empty state -->
                <div class="empty-state-sm" *ngIf="gruposSeleccionados.length === 0 && !mostrarBuscadorGrupo">
                    <span>No hay grupos. Toca <strong>+</strong> para agregar.</span>
                </div>
            </div>

            <!-- ======== ASUNTO ======== -->
            <div class="email-card">
                <div class="card-header">
                    <div class="header-title">
                        <ion-icon name="create-outline" color="tertiary"></ion-icon>
                        <span>Asunto del Correo</span>
                    </div>
                </div>
                <div class="input-group">
                    <div class="premium-input-wrapper">
                        <textarea
                            placeholder="Escribe el asunto aquí..."
                            [(ngModel)]="asunto"
                            id="input-asunto"
                            maxlength="200"
                            rows="2"
                            class="subject-textarea">
                        </textarea>
                    </div>
                    <div class="char-counter">{{ asunto.length }}/200</div>
                </div>
            </div>

            <!-- ======== PANEL SOLICITUD (solo visible en módulo SOLICITUD) ======== -->
            <div class="solicitud-panel" *ngIf="esSolicitud">

                <!-- === CALENDARIO SEMANAL PREMIUM === -->
                <div class="solicitud-section-title">
                    <ion-icon name="calendar-outline"></ion-icon>
                    <span>Fecha de Inicio</span>
                </div>
                <div class="solicitud-calendar-card">
                    <!-- Nav semanal -->
                    <div class="sol-week-nav">
                        <button class="sol-nav-btn" (click)="solicitudPrevWeek()">
                            <ion-icon name="chevron-back-outline"></ion-icon>
                        </button>
                        <span class="sol-week-label">{{ solicitudWeekLabel }}</span>
                        <button class="sol-nav-btn" (click)="solicitudNextWeek()">
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                        </button>
                    </div>
                    <!-- Grilla 7 días -->
                    <div class="sol-week-grid">
                        <div
                            *ngFor="let day of solicitudWeekDays; let i = index"
                            class="sol-day-cell"
                            [class.sol-today]="isSolicitudToday(day)"
                            [class.sol-selected]="isSolicitudSelected(day)"
                            (click)="seleccionarDiaSolicitud(day)">
                            <span class="sol-day-name">{{ SOLICITUD_DAY_NAMES[i] }}</span>
                            <span class="sol-day-num">{{ day.getDate() }}</span>
                        </div>
                    </div>
                    <!-- Fecha seleccionada pill -->
                    <div class="sol-selected-pill" *ngIf="solicitudFechaTexto">
                        <ion-icon name="checkmark-circle-outline"></ion-icon>
                        <span>{{ solicitudFechaTexto }}</span>
                    </div>
                </div>

                <!-- === SELECTOR DE HORA === -->
                <div class="solicitud-section-title">
                    <ion-icon name="time-outline"></ion-icon>
                    <span>Hora aproximada</span>
                </div>
                <div class="solicitud-time-card">
                    <div class="sol-time-row">
                        <!-- Hora -->
                        <div class="sol-time-group">
                            <div class="sol-time-label">Hora</div>
                            <div class="sol-time-scroller">
                                <div
                                    *ngFor="let h of SOLICITUD_HORAS"
                                    class="sol-time-option"
                                    [class.sol-time-selected]="solicitudHora === h"
                                    (click)="solicitudHora = h; onSolicitudTiempoChange()">
                                    {{ h }}
                                </div>
                            </div>
                        </div>
                        <div class="sol-time-separator">:</div>
                        <!-- Minutos -->
                        <div class="sol-time-group">
                            <div class="sol-time-label">Min</div>
                            <div class="sol-time-scroller sol-time-scroller-sm">
                                <div
                                    *ngFor="let m of SOLICITUD_MINUTOS"
                                    class="sol-time-option"
                                    [class.sol-time-selected]="solicitudMinutos === m"
                                    (click)="solicitudMinutos = m; onSolicitudTiempoChange()">
                                    {{ m }}
                                </div>
                            </div>
                        </div>
                        <div class="sol-time-separator sol-time-separator-sm"></div>
                        <!-- AM / PM -->
                        <div class="sol-time-group">
                            <div class="sol-time-label">Período</div>
                            <div class="sol-time-scroller sol-time-scroller-sm">
                                <div
                                    *ngFor="let p of SOLICITUD_AMPM"
                                    class="sol-time-option"
                                    [class.sol-time-selected]="solicitudAmPm === p"
                                    (click)="solicitudAmPm = p; onSolicitudTiempoChange()">
                                    {{ p }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Preview de hora -->
                    <div class="sol-time-preview">
                        <ion-icon name="alarm-outline"></ion-icon>
                        <span>{{ solicitudHoraTexto }}</span>
                    </div>
                </div>

                <!-- === ÍTEMS DE TRABAJOS === -->
                <div class="solicitud-section-title">
                    <ion-icon name="list-outline"></ion-icon>
                    <span>Trabajos a Realizar</span>
                    <span class="sol-items-count" *ngIf="solicitudItems.length > 0">{{ solicitudItems.length }}</span>
                </div>
                <div class="solicitud-items-card">
                    <!-- Input para agregar -->
                    <div class="sol-add-item-row">
                        <div class="sol-add-input-wrap">
                            <input
                                type="text"
                                placeholder="Ej: Aplicar primera mano de pintura..."
                                [(ngModel)]="nuevoItemTrabajo"
                                (keydown)="onItemKeydown($event)"
                                id="input-item-solicitud">
                        </div>
                        <button class="sol-add-btn" (click)="agregarItemSolicitud()" [disabled]="!nuevoItemTrabajo.trim()">
                            <ion-icon name="add-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Lista de ítems -->
                    <div class="sol-items-list" *ngIf="solicitudItems.length > 0">
                        <div class="sol-item-card" *ngFor="let item of solicitudItems; let i = index">
                            <div class="sol-item-bullet">
                                <span>{{ i + 1 }}</span>
                            </div>
                            <span class="sol-item-text">{{ item }}</span>
                            <button class="sol-item-remove" (click)="eliminarItemSolicitud(i)">
                                <ion-icon name="close-circle-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                    <div class="sol-items-empty" *ngIf="solicitudItems.length === 0">
                        <ion-icon name="construct-outline"></ion-icon>
                        <span>Agrega los trabajos a realizar</span>
                    </div>
                </div>

                <!-- === TRABAJADORES ASIGNADOS === -->
                <div class="solicitud-section-title">
                    <ion-icon name="people-outline"></ion-icon>
                    <span>Personal Asignado</span>
                    <span class="sol-items-count" *ngIf="solicitudTrabajadores.length > 0">{{ solicitudTrabajadores.length }}</span>
                </div>
                <div class="solicitud-items-card">
                    <!-- Botón para abrir modal de selección -->
                    <div class="sol-add-worker-row">
                        <ion-button expand="block" fill="outline" class="sol-add-worker-btn" (click)="abrirSelectorTrabajadores()">
                            <ion-icon name="person-add-outline" slot="start"></ion-icon>
                            Seleccionar Trabajadores
                        </ion-button>
                    </div>

                    <!-- Lista de trabajadores seleccionados -->
                    <div class="sol-items-list" *ngIf="solicitudTrabajadores.length > 0">
                        <div class="sol-item-card" *ngFor="let worker of solicitudTrabajadores; let i = index">
                            <div class="sol-item-bullet worker-bullet">
                                <ion-icon name="person-outline"></ion-icon>
                            </div>
                            <div class="sol-worker-info">
                                <span class="sol-item-text">{{ worker.nombre }}</span>
                                <span class="sol-item-subtext">Cédula: {{ worker.cedula || 'N/A' }}</span>
                            </div>
                            <button class="sol-item-remove" (click)="eliminarTrabajadorSolicitud(i)">
                                <ion-icon name="close-circle-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                    <div class="sol-items-empty" *ngIf="solicitudTrabajadores.length === 0">
                        <ion-icon name="people-outline"></ion-icon>
                        <span>No hay personal asignado</span>
                    </div>
                </div>
            </div>

            <!-- ======== ADJUNTOS ======== -->
            <div class="email-card">
                <div class="card-header">
                    <div class="header-title">
                        <ion-icon name="attach-outline" color="warning"></ion-icon>
                        <span>Adjuntos</span>
                    </div>
                    <ion-button fill="clear" size="small" class="add-btn" (click)="fileInput.click()" [disabled]="isSaving">
                        <ion-icon name="cloud-upload-outline" slot="icon-only"></ion-icon>
                    </ion-button>
                </div>

                <!-- Selector de Adjuntos ARS / INFT Premium -->
                <div class="premium-selector-container" *ngIf="moduloOrigen === 'ARS' && (tieneArs || tieneInft || tieneCotizacion)">
                    <div class="selector-title">Archivos de Sistema Disponibles</div>
                    <div class="premium-selector-grid">
                        <!-- Card ARS -->
                        <div class="premium-select-card" 
                             *ngIf="tieneArs" 
                             [class.selected]="adjuntarArs" 
                             (click)="adjuntarArs = !adjuntarArs; actualizarAdjuntosArs()">
                            <div class="card-status-dot"></div>
                            <div class="card-body-content">
                                <div class="icon-wrapper ars-icon">
                                    <ion-icon name="document-text-outline"></ion-icon>
                                </div>
                                <div class="card-text">
                                    <span class="card-label">Reporte ARS</span>
                                    <span class="card-desc">PDF Base</span>
                                </div>
                            </div>
                            <div class="selection-indicator">
                                <ion-icon name="checkmark-circle"></ion-icon>
                            </div>
                        </div>

                        <!-- Card INFT -->
                        <div class="premium-select-card" 
                             [class.selected]="adjuntarInft" 
                             [class.disabled]="!tieneInft"
                             (click)="toggleAdjuntoInft()">
                            <div class="card-status-dot"></div>
                            <div class="card-body-content">
                                <div class="icon-wrapper inft-icon">
                                    <ion-icon name="images-outline"></ion-icon>
                                </div>
                                <div class="card-text">
                                    <span class="card-label">Informe Final</span>
                                    <span class="card-desc">{{ tieneInft ? 'ARS + Fotos' : 'No Generado' }}</span>
                                </div>
                            </div>
                            <div class="selection-indicator">
                                <ion-icon name="checkmark-circle"></ion-icon>
                            </div>
                        </div>

                        <!-- Card Cotización -->
                        <div class="premium-select-card" 
                             [class.selected]="adjuntarCotizacion" 
                             [class.disabled]="!tieneCotizacion"
                             (click)="toggleAdjuntoCotizacion()">
                            <div class="card-status-dot"></div>
                            <div class="card-body-content">
                                <div class="icon-wrapper cot-icon">
                                    <ion-icon name="cash-outline"></ion-icon>
                                </div>
                                <div class="card-text">
                                    <span class="card-label">Cotización</span>
                                    <span class="card-desc">{{ tieneCotizacion ? 'PDF Vinculado' : 'No Vinculada' }}</span>
                                </div>
                            </div>
                            <div class="selection-indicator">
                                <ion-icon name="checkmark-circle"></ion-icon>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Input oculto de archivos -->
                <input
                    type="file"
                    #fileInput
                    multiple
                    (change)="onFilesSelected($event)"
                    accept="*/*"
                    style="display: none;">

                <!-- Zona de adjuntos -->
                <div
                    class="upload-zone"
                    [class.has-files]="adjuntosSeleccionados.length > 0"
                    (click)="fileInput.click()"
                    *ngIf="adjuntosSeleccionados.length === 0">
                    <div class="upload-content">
                        <ion-icon name="document-attach-outline"></ion-icon>
                        <p>Toca para seleccionar archivos</p>
                        <span class="hint">PDF, imágenes, Word, Excel...</span>
                    </div>
                </div>

                <!-- Lista de archivos adjuntos -->
                <div class="files-list" *ngIf="adjuntosSeleccionados.length > 0">
                    <div class="file-item" *ngFor="let f of adjuntosSeleccionados; let i = index">
                        <ion-icon [name]="getFileIcon(f.tipo)" class="file-type-icon"></ion-icon>
                        <div class="file-item-info" (click)="verAdjunto(f)">
                            <span class="file-item-name">{{ f.nombre }}</span>
                            <span class="file-item-size">{{ formatFileSize(f.tamanio) }}</span>
                        </div>
                        <button class="chip-remove danger" (click)="quitarAdjunto(i)">
                            <ion-icon name="trash-outline"></ion-icon>
                        </button>
                    </div>
                    <!-- Botón agregar más -->
                    <div class="add-more-files" (click)="fileInput.click()">
                        <ion-icon name="add-outline"></ion-icon>
                        <span>Agregar más archivos</span>
                    </div>
                </div>
            </div>

            <!-- ======== CUERPO DEL CORREO ======== -->
            <div class="email-card">
                <div class="card-header">
                    <div class="header-title">
                        <ion-icon name="mail-open-outline" color="success"></ion-icon>
                        <span>Cuerpo del Correo</span>
                    </div>
                    <div class="char-badge">{{ cuerpo.length }} caracteres</div>
                </div>
                <div class="input-group">
                    <div class="premium-input-wrapper textarea-wrapper">
                        <textarea
                            id="textarea-cuerpo"
                            placeholder="Redacta aquí el mensaje del correo..."
                            [(ngModel)]="cuerpo"
                            rows="8"
                            (input)="autoResize($event)">
                        </textarea>
                    </div>
                </div>
            </div>

            <!-- ======== RESUMEN ======== -->
            <div class="summary-card" *ngIf="destinatariosSeleccionados.length > 0 || gruposSeleccionados.length > 0">
                <div class="summary-header">
                    <ion-icon name="information-circle-outline"></ion-icon>
                    <span>Resumen</span>
                </div>
                <div class="summary-row">
                    <span class="summary-label">Destinatarios directos:</span>
                    <span class="summary-value">{{ destinatariosSeleccionados.length }}</span>
                </div>
                <div class="summary-row">
                    <span class="summary-label">Grupos:</span>
                    <span class="summary-value">{{ gruposSeleccionados.length }}</span>
                </div>
                <div class="summary-row">
                    <span class="summary-label">Total de contactos:</span>
                    <span class="summary-value highlight">{{ totalContactos }}</span>
                </div>
                <div class="summary-row" *ngIf="adjuntosSeleccionados.length > 0">
                    <span class="summary-label">Archivos adjuntos:</span>
                    <span class="summary-value">{{ adjuntosSeleccionados.length }}</span>
                </div>
            </div>

            <!-- ======== SECCION PREMIUM: BORRADORES E HISTORIAL ======== -->
            <div class="email-card p-0 overflow-hidden segment-container" *ngIf="idReferencia">
                <div class="segment-header">
                    <button 
                        class="segment-tab-btn" 
                        [class.active]="pestanaActiva === 'borradores'"
                        (click)="pestanaActiva = 'borradores'">
                        <ion-icon name="document-text-outline"></ion-icon>
                        <span>Borradores</span>
                        <span class="count-badge" *ngIf="borradores.length > 0">{{ borradores.length }}</span>
                    </button>
                    <button 
                        class="segment-tab-btn" 
                        [class.active]="pestanaActiva === 'historial'"
                        (click)="pestanaActiva = 'historial'">
                        <ion-icon name="time-outline"></ion-icon>
                        <span>Historial</span>
                        <span class="count-badge secondary" *ngIf="historialEnvios.length > 0">{{ historialEnvios.length }}</span>
                    </button>
                </div>

                <div class="segment-body ion-padding">
                    <!-- == VISTA BORRADORES == -->
                    <div *ngIf="pestanaActiva === 'borradores'" class="fade-in-tab">
                        <div class="spinner-container" *ngIf="cargandoBorradores">
                            <ion-spinner name="crescent" color="primary"></ion-spinner>
                            <p>Cargando borradores...</p>
                        </div>

                        <div *ngIf="!cargandoBorradores && borradores.length === 0" class="empty-tab-state">
                            <ion-icon name="document-outline" class="empty-icon"></ion-icon>
                            <h3>Sin Borradores</h3>
                            <p>No tienes borradores guardados para este registro.</p>
                        </div>

                        <div class="drafts-list" *ngIf="!cargandoBorradores && borradores.length > 0">
                            <div class="draft-card" *ngFor="let b of borradores">
                                <div class="draft-card-header">
                                    <div class="draft-meta">
                                        <span class="draft-user"><ion-icon name="person-outline"></ion-icon>{{ b.usuario }}</span>
                                        <span class="draft-date"><ion-icon name="calendar-outline"></ion-icon>{{ b.fecha }}</span>
                                    </div>
                                </div>
                                <div class="draft-card-body">
                                    <h4 class="draft-subject">{{ b.asunto || '(Sin Asunto)' }}</h4>
                                    <p class="draft-snippet">{{ b.cuerpo | slice:0:120 }}{{ b.cuerpo?.length > 120 ? '...' : '' }}</p>
                                </div>
                                <div class="draft-card-footer">
                                    <span class="draft-attachments-badge" *ngIf="b.adjuntos?.length > 0">
                                        <ion-icon name="attach-outline"></ion-icon>
                                        {{ b.adjuntos.length }} {{ b.adjuntos.length === 1 ? 'adjunto' : 'adjuntos' }}
                                    </span>
                                     <div style="flex: 1;"></div>
                                     <ion-button size="small" fill="clear" color="danger" class="delete-draft-btn" (click)="eliminarBorrador(b, $event)">
                                         <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
                                     </ion-button>
                                     <ion-button size="small" fill="solid" color="primary" class="apply-draft-btn" (click)="aplicarBorrador(b)">
                                         <ion-icon name="cloud-download-outline" slot="start"></ion-icon>
                                         Cargar
                                     </ion-button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- == VISTA HISTORIAL == -->
                    <div *ngIf="pestanaActiva === 'historial'" class="fade-in-tab">
                        <div class="spinner-container" *ngIf="cargandoHistorial">
                            <ion-spinner name="crescent" color="secondary"></ion-spinner>
                            <p>Cargando historial...</p>
                        </div>

                        <div *ngIf="!cargandoHistorial && historialEnvios.length === 0" class="empty-tab-state">
                            <ion-icon name="time-outline" class="empty-icon secondary"></ion-icon>
                            <h3>Sin Envíos</h3>
                            <p>No se registran envíos anteriores para este registro.</p>
                        </div>

                        <div class="timeline" *ngIf="!cargandoHistorial && historialEnvios.length > 0">
                            <div class="timeline-item" *ngFor="let h of historialEnvios" [class.timeline-item-fail]="h.estado === 'FALLIDO'" [class.timeline-item-pending]="h.estado === 'PENDIENTE'">
                                <div class="timeline-badge" [class.badge-fail]="h.estado === 'FALLIDO'" [class.badge-pending]="h.estado === 'PENDIENTE'">
                                    <ion-icon name="checkmark-done-circle" color="success" *ngIf="h.estado === 'ENVIADO'"></ion-icon>
                                    <ion-icon name="alert-circle" color="danger" *ngIf="h.estado === 'FALLIDO'"></ion-icon>
                                    <ion-icon name="time" color="warning" *ngIf="h.estado === 'PENDIENTE'"></ion-icon>
                                </div>
                                <div class="timeline-card" [class.card-fail]="h.estado === 'FALLIDO'" [class.card-pending]="h.estado === 'PENDIENTE'">
                                    <div class="timeline-card-header" (click)="toggleExpandirCorreo(h.id)">
                                        <div class="timeline-meta">
                                            <span class="timeline-user"><ion-icon name="person-outline"></ion-icon>{{ h.usuario }}</span>
                                            <span class="timeline-date"><ion-icon name="calendar-outline"></ion-icon>{{ h.fecha }}</span>
                                            <span class="status-pill fail" *ngIf="h.estado === 'FALLIDO'">FALLIDO</span>
                                            <span class="status-pill pending" *ngIf="h.estado === 'PENDIENTE'">PENDIENTE</span>
                                            <span class="status-pill success" *ngIf="h.estado === 'ENVIADO'">ENVIADO</span>
                                        </div>
                                        <h4 class="timeline-subject">{{ h.asunto }}</h4>
                                        <div class="timeline-to-list">
                                            <strong>Para:</strong> {{ h.destinatariosList.join(', ') }}
                                        </div>
                                        <div class="timeline-expand-btn">
                                            <span>{{ correoDetalleAbiertoId === h.id ? 'Ocultar Mensaje' : 'Ver Mensaje' }}</span>
                                            <ion-icon [name]="correoDetalleAbiertoId === h.id ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                                        </div>
                                    </div>
                                    
                                    <!-- Cuerpo expandible con transición -->
                                    <div class="timeline-card-body-wrapper" [class.expanded]="correoDetalleAbiertoId === h.id">
                                        <div class="timeline-card-body ion-padding">
                                            <div class="email-message-viewer">
                                                {{ h.cuerpo }}
                                            </div>
                                            
                                            <!-- Adjuntos en el historial -->
                                            <div class="timeline-attachments" *ngIf="h.adjuntos?.length > 0">
                                                <h5><ion-icon name="attach-outline"></ion-icon> Archivos Adjuntos:</h5>
                                                <div class="timeline-attachment-tags">
                                                     <span class="attachment-tag" *ngFor="let adj of h.adjuntos">
                                                         <ion-icon name="document-outline"></ion-icon>
                                                         {{ adj.alias || adj.nombre?.split('/').pop() || 'archivo' }}
                                                     </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </ion-content>

    <!-- ======== FOOTER DE ACCIONES ======== -->
    <div class="form-footer-actions">
        <ion-button
            id="btn-guardar-borrador"
            fill="outline"
            class="cancel-modal-btn"
            [disabled]="isSaving"
            (click)="guardarBorrador()">
            <ion-spinner name="crescent" *ngIf="isSaving && accionActual === 'GUARDAR'"></ion-spinner>
            <ng-container *ngIf="!(isSaving && accionActual === 'GUARDAR')">
                <ion-icon name="save-outline" slot="start"></ion-icon>
                Guardar
            </ng-container>
        </ion-button>

        <ion-button
            id="btn-enviar-correo"
            class="save-btn"
            [disabled]="isSaving || !isFormValid()"
            (click)="enviarCorreo()">
            <ion-spinner name="crescent" *ngIf="isSaving && accionActual === 'ENVIAR'"></ion-spinner>
            <ng-container *ngIf="!(isSaving && accionActual === 'ENVIAR')">
                <ion-icon name="send-outline" slot="start"></ion-icon>
                Enviar
            </ng-container>
        </ion-button>
    </div>
</div>
